import { initializeDrofusEndringerDateRange } from "../DrofusEndringer/drofusEndringerSlice";
import {
  type IMultiplacerModuleKey,
  LEFT_SIDEBAR_DEFAULT_TAB_BY_MODULE,
  MULTIPLACER_MODULES_BY_KEY,
  MODULE_DEFAULT_VIEW_PRESETS,
} from "@multiconsult-group/multiplacer-core";
import type { IAppThunk } from "../app/store";
import { setActiveModuleInRedux, setActiveLeftSideBarTabInRedux, setActiveRoomColoringIdInRedux } from "./designSlice";
import { applyViewerViewThunk } from "./applyViewerViewThunk";

export const changeActiveModuleThunk = (nextModule: IMultiplacerModuleKey): IAppThunk =>
  (dispatch, getState) => {
    if (getState().design.activeModule === nextModule) return;
    if (nextModule === "DROFUS_CHANGE_MANAGEMENT") dispatch(initializeDrofusEndringerDateRange());
    dispatch(setActiveModuleInRedux(nextModule));
    dispatch(setActiveLeftSideBarTabInRedux(LEFT_SIDEBAR_DEFAULT_TAB_BY_MODULE[nextModule]));
    const { defaultViewKey } = MULTIPLACER_MODULES_BY_KEY[nextModule];
    const defaultView = MODULE_DEFAULT_VIEW_PRESETS[defaultViewKey].view;
    // Module entry always resets room coloring, including when a view is selected.
    if (getState().viewer.selectedViewPreset) {
      dispatch(setActiveRoomColoringIdInRedux(defaultView.roomColoringId ?? undefined));
      return;
    }
    dispatch(applyViewerViewThunk(defaultView, { source: "builtIn", key: defaultViewKey }));
  };
